module.exports = __webpack_public_path__ + "img/t2-petition.40f734b9.png";